import React from "react";
import backgroundImage from "../../../assets/images/main_background.png";
import Grid from "@material-ui/core/Grid";
import WalletHeader from "../../../assets/images/img_wallet_header.png";
import SormeiBackground from "../../../assets/images/img_sormei_wallet.png";
import BalanceHolder from "../../pageComponents/Wallet/BalanceHolder";
import CardHolder from "../../pageComponents/Wallet/CardHolder";
import CardNumber from "../../../assets/images/ic_cardnumber.png";

import TransferBotton from "../../pageComponents/Wallet/TransferBotton";
import WalletButton from "../../pageComponents/Wallet/WalletButton";

import HistoryImage from "../../../assets/images/img_history_variz.png";
import WalletCoinSilver from "../../../assets/images/ic_wallet_coin_silver.png";
import WalletCoinGold from "../../../assets/images/ic_wallet_coini.png";
import Item from "../../pageComponents/Settings/Item";
import Toolbar from "../../Toolbar";
import axios from "axios";
import {freeGiftRedeem, userData, walletGet, walletReqPay} from "../../../Utility/Url";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {data} from "../../../Store/Actions/DataAction";
import DiscountCodeHolder from "../../../assets/images/wood_dig_store.png";
import WoodenInput from "../../pageComponents/Settings/Free/WoodenInput";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "../../pageComponents/Common/Dialog";

class WalletIndex extends React.Component{
    constructor() {
        super()
        this.inputRef = React.createRef()
        this.state= {
            showDialog:false,
            dialogDetail:null,
            appHasLoaded: false,
            dataLoaded:null,
            rxLoaded:false,
            picoSmallLoader:false,
            style: {
                completed: 5,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor: "#01c89c",
                    backgroundBlendMode:'soft-light',
                    flex:1,
                    minHeight:'0'
                },
            }
        }

    }
    fetchData= async()=>{
        await axios.get(userData)
            .then(res => {
                const {data}=res
                this.props.data(data)
                this.setState({
                    rxLoaded:true
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    fetchWalletData= async()=>{
        await axios.get( walletGet)
            .then(res => {
                const {data}=res
                this.setState({
                    dataLoaded:data
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    async componentDidMount(){
        this.props.toggleBottomNavbar(true)
        await this.fetchData()
        await this.fetchWalletData()
    }
    toggleIndexNav=(data)=>{
        switch (data) {
            case 'open':
                this.props.toggleBottomNavbar(false)
                this.setState({
                    infoSectionOpacity:'0',
                })
                break
            case 'close':
                this.props.toggleBottomNavbar(true)
                this.setState({
                    infoSectionOpacity:'1',
                })
                break
            default:
                this.props.toggleBottomNavbar(true)
                this.setState({
                    infoSectionOpacity:'1',
                })
        }
    }
    handleDialog=(data)=>{
        this.setState({
            dialogDetail:data.dialog,
            showDialog:true,
        })
    }
    handleDialogAction=(action)=>{
        switch (action) {
            case '#cancel':
                this.setState({
                    showDialog:false,
                })
                break
            default:
                this.setState({
                    showDialog:false,
                })
        }
    }
    handleInput=(data)=>{
    }
    handleClick=async ()=>{
        this.setState({
            picoSmallLoader:true
        })
        const card=this.inputRef.current.state.input
        await axios.post(walletReqPay,{
            card:card
        })
            .then(res => {
                const {data}=res
                this.handleDialog(data)
                this.setState({
                    picoSmallLoader:false
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    render() {
        const {dataLoaded,rxLoaded} = this.state
        let value = '0'

        if (rxLoaded){
            const data=this.props.UserData.userData
            value=data.userInfo.cardNum
        }
        const buttons=[
            {
                icon: HistoryImage,
                text: 'تاریخچه کیف پول',
                textColor:'#ffffff',
                direction:'row',
                visible:true,
                id:'wallethistory',
                hasDialog:true
            },
            {
                icon:HistoryImage,
                text:'تاریخچه واریز',
                textColor:'#ffffff',
                direction:'row',
                visible:true,
                id:'walletreqpayhistory',
                hasDialog:true
            },
            {
                icon: WalletCoinGold,
                text: 'تبدیل به سکه طلا',
                textColor:'yellow',
                direction:'column',
                visible:true,
                id:'goldConverter',
                hasDialog:false
            },
            {
                icon: WalletCoinSilver,
                text: 'تبدیل سکه به نقره',
                textColor:'#ffffff',
                direction:'column',
                visible:true,
                id:'silverConverter',
                hasDialog:false
            },
        ]
        const woodenInput={
            backgroundColor:'transparent',
            layerRadius:'15px',
            inputTextSize:'15px',
            inputMaxLength:'16',
            placeHolder:'شماره کارت خود را وارد کنید',
            holderImage:CardNumber,
            color:'#fffffff',
            value:value
        }


        const {dialogDetail,picoSmallLoader}=this.state
        const customDialog={
            button:{
                text:'',
                backgroundColor:'transparent',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog:dialogDetail,
            }
        }
        const handleClose=(()=>{
            this.setState({
                showDialog:false
            })
        })
        return(
            <Grid style={this.state.style.root} direction={"column"} item container>
                <Dialog
                    // disableBackdropClick
                    open={this.state.showDialog}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    }}
                >
                    <DialogContent>
                        <CustomDialog action={this.handleDialogAction} data={customDialog}/>
                    </DialogContent>
                </Dialog>
                {
                    this.state.dataLoaded &&
                    <Grid item sm={12} justify={'center'} container direction={"column"}
                          style={{flex: '1', minHeight: '0'}}>
                        <Grid item container id={"TTT"}>
                            <Toolbar type='sideToolbar'/>
                        </Grid>
                        <Grid item direction={"column"} container wrap={"nowrap"} className='scrollBar'
                              style={{flex: '1', minHeight: '0', overflow: 'auto'}}>

                            <Grid container item justify={'center'} className='wallet-header-section'>
                                <img className='wallet-header-section-background' src={WalletHeader} alt=""/>
                                <Grid container alignItems='center' className='wallet-header-section-card-section' item
                                      justify={'space-around'}
                                      style={{
                                          backgroundImage: "url(" + SormeiBackground + ")",
                                          backgroundSize: '80% 100%',
                                          backgroundRepeat: 'no-repeat',
                                          backgroundPosition: 'center',
                                          height: '200%'
                                      }}>
                                    <Grid item sm={8} xs={8}>
                                        {/*<BalanceHolder data={value}/>*/}
                                        <BalanceHolder data='0'/>
                                    </Grid>
                                    <Grid item sm={7} xs={7} style={{marginTop: '20px'}}>
                                        {/*<CardHolder/>*/}
                                        <WoodenInput input={this.handleInput} data={woodenInput}  ref={this.inputRef}/>
                                    </Grid>
                                    { !picoSmallLoader &&
                                    <Grid  sm={6} xs={6} item style={{marginTop: '20px'}}>
                                        <Grid  sm={12} xs={12} item className='clickable'
                                               onClick={()=>{this.handleClick()}}>
                                            <TransferBotton/>
                                        </Grid>
                                    </Grid>
                                    }
                                    {
                                        picoSmallLoader &&
                                        <Grid sm={6} xs={6} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                        >
                                            <Grid style={{position:'relative',height:'50px'}} sm={2} xs={2} justify={"center"} container alignItems={"center"}>
                                                <Grid item container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                                    <PicoLoader/>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }

                                </Grid>
                            </Grid>
                            <Grid item container justify='space-evenly' style={{marginTop: '55%', marginBottom: '10%'}}>
                                {buttons.map(data => {
                                    return <Grid item sm={5} xs={5} style={{margin: '5px 0 5px 0'}}>
                                        <WalletButton dialog={this.handleDialog} toggleIndexNav={this.toggleIndexNav} data={data} info={dataLoaded}/>
                                    </Grid>
                                })}
                            </Grid>
                        </Grid>
                    </Grid>
                }
                {
                    !this.state.dataLoaded &&
                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                          style={{position:'relative',
                              top:'50%',left:'50%',transform:'translate(-50%,-50%)'}}
                    >
                        <Grid item container justify={"center"} style={{position:'absolute',
                        }}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                }
            </Grid>
        )
    }
}
const Wallet=withRouter (WalletIndex)
const mapStateToProps=state=>({
    UserData:state.UserData
})
export default connect(mapStateToProps,{data})(Wallet)